import { PlatformEdition } from 'src/types/platform-feature';

/**
 * The i18next `context` each edition reads its UI copy with. With a context set,
 * `t('key')` resolves `key_<context>` first and falls back to `key`, so only the strings
 * that actually differ for an edition get a variant. `null` = the base wording.
 *
 * Exhaustive: a new edition fails to compile until its wording is decided.
 */
export const EDITION_I18N_CONTEXT: Record<PlatformEdition, string | null> = {
  [PlatformEdition.CREATOR]: null,
  [PlatformEdition.CORPORATE]: 'corporate',
};
